export default __webpack_public_path__ + "static/Strategy-e139c0dd3a044c2a27cc0abeb41823b0.webp";